import { Button, Divider, Flex, Icon, useDisclosure } from '@chakra-ui/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { IoIosMenu } from 'react-icons/io';

import ProfileModal from '../../../components/ProfileModal';
import SidebarAccountHeader from '../../../components/Sidebar/SidebarAccountHeader';
import SidebarDrawer from '../../../components/Sidebar/SidebarDrawer';
import SidebarNavLink from '../../../components/Sidebar/SidebarNavLink';
import { LDFlags } from '../../../constants/flags';
import { useAccountMenu, useFlag } from '../../../hooks';
import Notifications, {
  notificationsDrawerOpenAtom,
  unseenNotificationCountAtom,
} from '../notifications/Notifications';
import UnreadCountBubble from '../notifications/UnreadCountBubble';

const MobileHeaderMenu = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const notificationsEnabled = useFlag(LDFlags.PASSWORDLESS_DASHBOARD_ACCESS);
  const unseenCount = useAtomValue(unseenNotificationCountAtom);
  const openNotifications = useSetAtom(notificationsDrawerOpenAtom);
  const {
    hasAccount,
    isOnDashboard,
    goToDashboard,
    handleLogout,
    customer,
    profileModalOpen,
    setProfileModalOpen,
  } = useAccountMenu();

  const handleOpenNotifications = () => {
    onClose();
    openNotifications(true);
  };

  return (
    <>
      <Button
        aria-label="Menu"
        variant="link"
        position="relative"
        onClick={onOpen}
        ml={2}
        minW="auto"
      >
        {notificationsEnabled && (
          <UnreadCountBubble count={unseenCount} position="absolute" top={-1} right={-1} />
        )}
        <Icon as={IoIosMenu} boxSize="32px" color="taupeGray" />
      </Button>

      <SidebarDrawer isOpen={isOpen} onClose={onClose}>
        <SidebarAccountHeader name={customer?.full_name} email={customer?.email} />
        <Flex flexDir="column" gap="15px" mt="10px">
          {notificationsEnabled && (
            <Flex alignItems="center" gap={2}>
              <SidebarNavLink onClick={handleOpenNotifications}>Notifications</SidebarNavLink>
              <UnreadCountBubble count={unseenCount} />
            </Flex>
          )}
          {hasAccount && (
            <SidebarNavLink onClick={() => setProfileModalOpen(true)}>Profile</SidebarNavLink>
          )}
          {!isOnDashboard && <SidebarNavLink onClick={goToDashboard}>My Dashboard</SidebarNavLink>}
          <Divider m="10px 0" />
          <SidebarNavLink onClick={handleLogout}>Logout</SidebarNavLink>
        </Flex>
      </SidebarDrawer>

      {notificationsEnabled && <Notifications showBell={false} />}

      <ProfileModal open={profileModalOpen} setOpen={setProfileModalOpen} customer={customer} />
    </>
  );
};

export default MobileHeaderMenu;
